import { IAggregate } from "@shared/lib/types/briefCampains";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { Alert, Tag } from "antd";

interface TotalDetailsProps {
  aggregate: IAggregate;
}

export function TotalDetails({ aggregate }: TotalDetailsProps) {
  const ledgerBase = aggregate.ledger.base;
  const ledgerGst = aggregate.ledger.gst;
  const invoiceTotal = aggregate.invoices.base;
  const invoiceLeft = aggregate.invoices.left;
  const payoutTotal = aggregate.payments.base.total;
  const payoutLeft = aggregate.payments.base.left;
  const gstPayoutTotal = aggregate.payments.gst.total;
  const gstPayoutLeft = aggregate.payments.gst.left;

  const isCompleted = payoutLeft === 0;
  const isError = payoutLeft < 0 || gstPayoutLeft < 0;

  return (
    <>
      {isError && (
        <Alert
          message="Payout exceeds the Ledger Amount"
          type="error"
          showIcon
          description="Payout exceeds the ledger because an advance was paid to the influencer. Before cancelling, ensure the paid amount is returned or adjusted through a credit entry to maintain accurate financial records."
        />
      )}

      <div
        className={classNames(
          styles.card,
          isCompleted ? styles.completedCard : styles.pendingCard,
          isError ? styles.errorCard : ""
        )}
        style={{
          borderRadius: 12,
          padding: 20,
          marginBottom: 16,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 32,
        }}
      >
        {/* Ledger */}
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Ledger</div>
          <div className={styles.sectionValue}>
            ₹{ledgerBase} +{" "}
            <span className={styles.gst}>(₹{ledgerGst} GST)</span>
          </div>
        </div>
        {/* Invoice */}
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Invoice</div>
          <div className={styles.sectionValue}>₹{invoiceTotal}</div>
          <div className={styles.sectionSub}>₹{invoiceLeft} Left to make</div>
        </div>
        {/* Payout */}
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Payout</div>
          <div className={styles.sectionValue}>₹{payoutTotal}</div>
          {isCompleted ? (
            <Tag color="purple">Completed</Tag>
          ) : (
            <div className={styles.sectionSub}>
              ₹{payoutLeft} Left to {isError ? "Deposit" : "Pay"}
            </div>
          )}
        </div>
        {/* GST Payout */}
        <div className={styles.section}>
          <div className={styles.sectionTitle}>GST Payout</div>
          <div className={styles.sectionValue}>₹{gstPayoutTotal}</div>
          <div className={styles.sectionSub}>₹{gstPayoutLeft} Left to pay</div>
        </div>
      </div>
    </>
  );
}
